const pointerEvents = {
  name: "pointer-events",
  path: "/pointer-events",
  title: "pointer-events",
  description: "Utilities for controlling the CSS pointer-events property.",
  value: {
    "pointer-events": {
      "pointer-events-none": "none",
      "pointer-events-auto": "auto"
    }
  },
  exampleData: [
    {
      example: {
        code: `<button class="pointer-events-none px-4 py-2 border rounded">No pointer events</button>
<button class="pointer-events-auto px-4 py-2 border rounded">Pointer events enabled</button>`
      }
    }
  ],
  htmlData: [
    {
      title: "Pointer events",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">pointer-events-none</code> or <code class="text-color-gray-800 dark:text-color-white font-semibold">pointer-events-auto</code> to control pointer events.
      </p>
        <div class="grid grid-columns-1 gap-10 px-0 sm:grid-columns-2 sm:px-10">
            <div class="flex flex-col">
                <p class="mb-3 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">pointer-events-auto</p>
                <div class="relative w-full rounded-lg shadow-sm">
                    <div class="pointer-events-auto absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg class="absolute h-5 w-5  text-color-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
                    </svg>
                    </div>
                    <input placeholder="Search" class=" block w-full rounded-lg px-3 py-2 pl-10 font-sans text-sm text-color-gray-500 ring-1 ring-color-gray-900/10 dark:bg-color-gray-800 dark:text-color-gray-400 dark:ring-0" type="text">
                </div>
            </div>
            <div class="flex flex-col">
                <p class="mb-3 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">pointer-events-none</p>
                <div class="relative w-full rounded-lg shadow-sm">
                    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg class="absolute h-5 w-5 text-color-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
                    </svg>
                    </div>
                    <input placeholder="Search" class=" block w-full rounded-lg px-3 py-2 pl-10 font-sans text-sm text-color-gray-500 ring-1 ring-color-gray-900/10 dark:bg-color-gray-800 dark:text-color-gray-400 dark:ring-0" type="text">
                </div>
            </div>
        </div>
      `
    }
  ]
};

export default pointerEvents;
<div className="sr-only flex gap-4 flex-wrap">
    <div class="grid grid-columns-1 gap-10 px-0 sm:grid-columns-2 sm:px-10">
            <div class="flex flex-col">
                <p class="mb-3 font-mono text-xs font-medium text-gray-500 dark:text-gray-400">pointer-events-auto</p>
                <div class="relative w-full rounded-lg shadow-lg">
                    <div class="pointer-events-auto absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg class="absolute h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
                    </svg>
                    </div>
                    <input placeholder="Search" class=" block w-full rounded-lg px-3 py-2 pl-10 font-sans text-sm text-color-gray-500 ring-1 ring-color-gray-900/10 dark:bg-color-gray-800 dark:text-color-gray-400 dark:ring-0" type="text"/>
                </div>
            </div>
            <div class="flex flex-col">
                <p class="mb-3 font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">pointer-events-none</p>
                <div class="relative w-full rounded-lg shadow-sm">
                    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg class="absolute h-5 w-5 text-color-gray-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
                    </svg>
                    </div>
                    <input placeholder="Search" class=" block w-full rounded-lg px-3 py-2 pl-10 font-sans text-sm text-color-gray-500 ring-1 ring-color-gray-900/10 dark:bg-color-gray-800 dark:text-color-gray-400 dark:ring-0" type="text"/>
                </div>
            </div>
        </div>
</div>